// Otomatik ortam algılama
const getApiUrl = () => {
  const hostname = window.location.hostname;

  // Localhost kontrolü
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:3201/api';
  }

  // Production - subdomain'den ana domain'i çıkar
  // vale.veribil.com.tr -> api.veribil.com.tr
  const domain = hostname.replace('vale.', '');
  return `https://api.${domain}/api`;
};

// Environment variables fallback (build time)
export const API_URL = process.env.REACT_APP_API_URL || getApiUrl();

// Debug log
if (process.env.NODE_ENV === 'development') {
  console.log('API Configuration:', {
    hostname: window.location.hostname,
    API_URL
  });
}

export default {
  API_URL
};